import React from "react";
import { Chip, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getReferralDisplay } from "../utils/referralFlags";

const referralStyles = {
  in: { bg: "#dbeafe", text: "#1d4ed8", border: "#bfdbfe" },
  out: { bg: "#ffedd5", text: "#c2410c", border: "#fed7aa" },
  both: { bg: "#f3e8ff", text: "#7e22ce", border: "#e9d5ff" },
  none: { bg: "#f1f5f9", text: "#64748b", border: "#e2e8f0" },
};

function ReferralFlag({ item, emptyText = "---", size = "small" }) {
  const { t } = useTranslation();
  const referral = getReferralDisplay(item);

  if (!referral.type) {
    return <span className="text-gray-400 text-xs">{emptyText}</span>;
  }

  const styles = referralStyles[referral.tone] || referralStyles.none;
  const tooltip =
    referral.type === "referred_in"
      ? t("Reason-for-visit referral found in supporting info")
      : referral.type === "referred_out"
        ? t("Referral flag is enabled")
        : t("Referral in and out");

  return (
    <Tooltip title={tooltip}>
      <Chip
        label={t(referral.label)}
        size={size}
        sx={{
          backgroundColor: styles.bg,
          color: styles.text,
          border: `1px solid ${styles.border}`,
          borderRadius: "6px",
          fontSize: "10px",
          fontWeight: 800,
          height: 20,
          textTransform: "uppercase",
          "& .MuiChip-label": { px: "12px" },
        }}
      />
    </Tooltip>
  );
}

export default ReferralFlag;
